import { ConfigType } from '../utils/requestAPI';

type RegisterDataType = {
  fullName: string;
  emailAddress: string;
  password: string;
  role: 'CLIENT' | 'TECHNICIAN' | 'ADMIN' | 'PRINTER';
};

type VerifyOTPType = {
  otpType: string;
  otp: number;
  emailAddress: string;
};

type LoginDataType = {
  emailAddress: string;
  password: string;
};
type ResendOTPType = {
  otpType: string;
};

type RefreshTokenDataType = {
  refreshToken: string;
};
type OnboardingDataType = {
  onboardingStep?: number;
  role?: string;
  fullName?: string;
  password?: string;
  emailAddress?: string;
  mobileNumber?: string;

  countryCode?: string;
  postalCode?: string;
  companyName?: string;
  cardNumber?: string;
  expirationDate?: string;
  cvc?: string;
  contactInfo?: {
    address1?: string;
    address2?: string;
    city?: string;
    country?: string;
    postalCode?: string;
  };
  companyDetails?: {
    companyName?: string;
  };

  paymentMethod?: string;
  skip?: boolean;
};
type createUserByAdminType = {
  department: string;
  fullName: string;
  emailAddress: string;
  contactInfo: {
    address1: string;
  };
  password: string;
};
type ResetPassword = {
  emailAddress: string;
  otpType: string;
  otp: number;
  newPassword: string;
};
type ChangePassword = {
  currentPassword: string;

  newPassword: string;
};
const authApis = {
  register: (data: RegisterDataType): ConfigType => {
    return {
      url: '/auth/register',
      method: 'post',
      data,
      config: {
        store: {
          action: 'set',
          key: 'users',
        },
      },
    };
  },
  verifyOTP: (data: VerifyOTPType): ConfigType => {
    return {
      url: '/auth/verify-otp',
      method: 'post',
      data: data,
    };
  },
  refreshToken: (data: RefreshTokenDataType): ConfigType => {
    return {
      url: '/auth/refreshToken',
      method: 'post',
      data: data,
    };
  },
  resendOTP: (data: ResendOTPType): ConfigType => {
    return {
      url: '/Auth/otp-resend',
      method: 'post',
      data: data,
    };
  },
  login: (data: LoginDataType): ConfigType => {
    return {
      url: '/auth/login',
      method: 'post',
      data,
    };
  },
  onBoarding: (data: OnboardingDataType): ConfigType => {
    return {
      url: '/auth/onboarding',
      method: 'post',
      data,
    };
  },
  createUserByAdmin: (data: createUserByAdminType): ConfigType => {
    return {
      url: '/auth/user-create-by-admin',
      method: 'post',
      data,
    };
  },
  forgotPassword: (email: string): ConfigType => {
    return {
      url: '/auth/forgot-password',
      method: 'post',
      data: {
        emailAddress: email,
      },
    };
  },
  resetPassword: (data: ResetPassword): ConfigType => {
    return {
      url: '/auth/reset-password',
      method: 'post',
      data,
    };
  },
  resendOtpWithEmail: (email: string): ConfigType => {
    return {
      url: '/auth/forgot-password',
      method: 'post',
      data: {
        emailAddress: email,
      },
    };
  },
  logOut: (): ConfigType => {
    return {
      url: '/auth/logout',
      method: 'get',
    };
  },
  changePassword: (data: ChangePassword): ConfigType => {
    return {
      url: '/auth/user/change-password',
      method: 'post',
      data,
    };
  },
};

export default authApis;
